
import React from 'react';

const DashboardLoading: React.FC = () => {
  return (
    <main className="flex-1 container mx-auto p-4 md:p-6">
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-sm text-muted-foreground">Loading dashboard data...</p>
        </div>
      </div>
    </main>
  );
};

export default DashboardLoading;
